import React, { Fragment, useEffect, useState } from 'react'
import { getFirestore, onSnapshot, collection } from 'firebase/firestore'
import { initializeApp } from '@firebase/app'

import { Form, Card, Table, Col, Dropdown, Row } from 'react-bootstrap'
import config from '../../config'

initializeApp(config.firebase)
const db = getFirestore()

const Monitor = () => {
  const [status, setStatus] = useState([])
  const [monitor, setMonitor] = useState('Select')
  const [dataObject, setDataObject] = useState()

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'service-status'), (snapshot) => {
      const status = snapshot.docs.map((doc) => {
        return { id: doc.id, data: doc.data() }
      })
      setStatus(status)
    })
    return () => {
      unsubscribe()
    }
  }, [])
  useEffect(() => {
    const data = status.filter((s) => s.id === monitor).map((d) => d.data)
    let test = data[0]
    setDataObject(test)
  }, [monitor, status])
  //console.log(dataObject && Object.keys(dataObject).map((s,i)=>dataObject[s][0]));
  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Monitors</Card.Title>
        </Card.Header>

        <Card.Body>
          <Form>
            <Row>
              <b style={{ marginTop: '17px', marginLeft: '20px' }}>Type:</b>
              <Col sm={12} md={6} lg={4}>
                <Dropdown>
                  <select
                    className="form-control"
                    style={{ color: '#5d5d5d' }}
                    onChange={async (value) => {
                      setMonitor(value.target.value)
                    }}
                  >
                    <option>Select</option>
                    {status &&
                      status.map((s) => (
                        <option key={`option_${s.id}`} value={s.id}>
                          {s.id}
                        </option>
                      ))}
                  </select>
                </Dropdown>
              </Col>
            </Row>
          </Form>
          <br />

          <Table responsive striped bordered className="verticle-middle">
            <thead>
              <tr>
                {dataObject !== undefined &&
                  Object.keys(dataObject)
                    .sort()
                    .map((i) => {
                      return <th key={i}>{i}</th>
                    })}
              </tr>
            </thead>
            <tbody>
              <tr>
                {dataObject !== undefined &&
                  Object.keys(dataObject)
                    .sort()
                    .map((key, i) => {
                      switch (key) {
                        case 'startDate':
                          return <td key={i}>{new Date(dataObject[key].seconds * 1000).toLocaleDateString('th-TH')}</td>
                        case 'วันที่เริ่ม':
                          return <td key={i}>{new Date(dataObject[key].seconds * 1000).toLocaleDateString('th-TH')}</td>
                        case 'updatedAt':
                          return <td key={i}>{new Date(dataObject[key].seconds * 1000).toLocaleDateString('th-TH')}</td>
                        case 'value':
                          return (
                            <td key={i}>
                              {dataObject[key].length === 2 ? dataObject[key] : dataObject[key].toLocaleString()}
                            </td>
                          )

                        default:
                          return <td key={i}>{dataObject[key].toLocaleString()}</td>
                      }
                    })}
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default Monitor
